import { notification } from 'antd';
import {
  createNewBuyerFx,
  fetchBuyersListFx,
  setActiveBuyer,
} from '../store/buyers.store';
import { BuyerInstance } from '../ts';

export const handleSubmit = async (
  newBuyerDto: BuyerInstance,
  sortOption: {
    label: string;
    val: string;
    active: boolean;
  }[],
  orderBy: 'asc' | 'desc',
  searchString: string,
  setSearchParams: any,
  setShowBuyerModal: (value: React.SetStateAction<boolean>) => void,
) => {
  const errors = [];
  if (
    !newBuyerDto.company_name ||
    !newBuyerDto.address ||
    !newBuyerDto.country ||
    !newBuyerDto.tel ||
    !newBuyerDto.email
  ) {
    errors.push({
      message: 'Не заполнены обязательные поля',
      description: 'Поля, отмеченные знаком "*" являются обязательными к заполнению',
    });
  }

  if (newBuyerDto.company_name.length < 5 || newBuyerDto.company_name.length > 128) {
    errors.push({
      message: 'Некорректное название компании',
      description: 'Название компании может содержать от 5 до 128 символов',
    });
  }

  if (!newBuyerDto.email.includes('@') || !newBuyerDto.email.includes('.')) {
    errors.push({
      message: 'Некорректный email',
      description: 'Email указан в неправильном формате',
    });
  }

  if (
    newBuyerDto.region === '' ||
    newBuyerDto.street === '' ||
    newBuyerDto.house === ''
  ) {
    errors.push({
      message: 'Некорректный адрес',
      description: 'Укажите полный адрес, включая регион, город, дом',
    });
  }

  if (newBuyerDto.tel.length !== 12)
    errors.push({
      message: 'Некорректный номер телефона',
      description: 'Номер телефона указан в неправильном формате',
    });

  if (newBuyerDto.inn.length > 0 && newBuyerDto.inn.length !== 10) {
    errors.push({
      message: 'Некорректный  ИНН',
      description: 'ИНН должен содержать 10 цифр',
    });
  }

  if (newBuyerDto.ogrn.length > 0 && newBuyerDto.ogrn.length !== 13) {
    errors.push({
      message: 'Некорректный  ОГРН',
      description: 'ОГРН должен содержать 13 цифр',
    });
  }

  if (errors.length > 0) {
    return errors.map((errItem) => notification.warning(errItem));
  }

  const res: any = await createNewBuyerFx(newBuyerDto);
  if ('error' in res) {
    const errorRes = res as any;
    const errorArray = Object.keys(errorRes.error.errors).reduce((result, key) => {
      return result.concat(errorRes.error.errors[key]);
    }, []);
    if (errorArray && errorArray.length > 0) {
      errorArray.map((item) => notification.error({ message: item }));
      return;
    }
    return notification.error({
      message: 'Непредвиденная ошибка. Попробуйте позже.',
    });
  }
  await fetchBuyersListFx({
    sortBy: sortOption.find((item) => item.active)?.val,
    orderBy,
    search: searchString,
  });
  setActiveBuyer(+res.id);
  setSearchParams({ selected_buyer: String(res.id) });
  notification.success({ message: 'Покупатель успешно добавлен в систему!' });
  setShowBuyerModal(false);
};
